import { Card } from '@/components';
import { icCoinGold, icIntGold } from '@/components/GenericsTournaments/Icons/';
import { useIsDesktop } from '@/hooks/useIsDesktop';
import useTourney from '@/hooks/useTourney';
import { TipoProductoTO } from '@/types/myAccount';
import { formatNumberToLocale } from '@/utils';

const InfoContent = ({ product }: { product?: TipoProductoTO }) => {
  const { isDesktop } = useIsDesktop();
  const { tourneyData } = useTourney();
  const data = product
    ? {
        tourneyPrice: product.montoPremio,
        tourneyPinPrice: product.precio,
      }
    : tourneyData;

  return (
    <>
      {isDesktop ? (
        <div className="text-left overflow-y-auto scrollbar-hide max-h-[80vh] [&::-webkit-scrollbar]:hidden [-ms-overflow-style:'none'] [scrollbar-width:'none']">
          <div className="flex flex-col items-center">
            <h6 className="lg:text-center lg:text-base text-sm font-bold text-gdt-blue-header flex lg:items-center max-sm:max-w-[250px]">
              <figure className="min-w-8">
                <img
                  alt="Icono de moneda"
                  className="h-[35px]"
                  src={icCoinGold}
                />
              </figure>
              <span className="ps-2">¿Qué son las Fechas de Oro?</span>
            </h6>
            <p className="my-2 text-ce ml-4">
              La Fecha de Oro es una competencia especial dentro de Gran DT,{' '}
              {`de la que participan 20 DT’s en una fecha determinada, por $${formatNumberToLocale(
                data.tourneyPrice ?? 0
              )}`}
              .
            </p>
          </div>
          <div className="flex flex-col items-center">
            <h6 className="lg:text-center lg:text-base text-sm font-bold text-gdt-blue-header flex lg:items-center max-sm:max-w-[250px]">
              <figure className="min-w-8">
                <img
                  alt="Icono de moneda"
                  className="h-[35px]"
                  src={icIntGold}
                />
              </figure>
              <span className="ps-2">¿Cómo se participa?</span>
            </h6>
            <p className="my-2 ml-4">
              Para anotarse, los DT’s deben obtener su pin especial de
              {` $${formatNumberToLocale(data.tourneyPinPrice ?? 0)}`} desde la
              sección Mis Pines. Cada torneo tendrá 20 participantes que
              competirán entre sí con sus equipos de Primera División. Podrá
              haber más de un torneo “Fecha de Oro” por fecha, pudiendo
              participar solo 20 DT’s en cada torneo.
              <br />
              <br />
              El ganador es el técnico que más puntos suma en la fecha con su
              equipo de Primera División.
            </p>
          </div>
        </div>
      ) : (
        <div className="flex flex-col gap-4">
          <Card className="!px-6 !pb-8 !w-auto !pt-4 bg-white">
            <h6 className="lg:text-center lg:text-base text-sm font-bold text-gdt-blue-header flex lg:items-center max-sm:max-w-[250px]">
              <figure className="min-w-8">
                <img
                  alt="Icono de interrogacion"
                  className="h-[35px]"
                  src={icCoinGold}
                />
              </figure>
              <span className="ps-2">¿Qué son las Fechas de Oro?</span>
            </h6>
            <p className="my-2">
              <span className="font-semibold">
                La Fecha de Oro es una competencia especial
              </span>{' '}
              {`dentro de Gran DT, de la que participan 20 DT’s en una fecha determinada, por $${formatNumberToLocale(
                data.tourneyPrice ?? 0
              )}`}
              .
            </p>
          </Card>
          <Card className="!px-6 !pb-8 !w-auto !pt-4 bg-white">
            <h6 className="lg:text-center lg:text-base text-sm font-bold text-gdt-blue-header flex lg:items-center max-sm:max-w-[250px]">
              <figure className="min-w-8">
                <img
                  alt="Icono de interrogacion"
                  className="h-[35px]"
                  src={icIntGold}
                />
              </figure>
              <span className="ps-2">¿Cómo se participa?</span>
            </h6>
            <p className="">
              Para anotarse, los DT’s deben
              <span className="font-semibold">
                {` obtener su pin especial de $${formatNumberToLocale(
                  data.tourneyPinPrice ?? 0
                )} `}
              </span>
              desde la sección Mis Pines. Cada torneo tendrá 20 participantes
              que competirán entre sí con sus equipos de Primera División. Podrá
              haber más de un torneo “Fecha de Oro” por fecha, pudiendo
              participar solo 20 DT’s en cada torneo.
            </p>
            <p>
              {' '}
              El ganador es el técnico que más puntos suma en la fecha con su
              equipo de Primera División.
            </p>
          </Card>
        </div>
      )}
    </>
  );
};

export default InfoContent;
